<template>
    <div class="factory-research-faults">
        <el-row class="factory-research-fault-title">
            <el-col :span="3">
                <span class="h3">异常库</span>
            </el-col>
            <el-col :span="6" :offset="13">
                <div class="factory-research-fault-title-filter">
                    <span class="label">异常搜索：</span>
                    <el-input placeholder="请输入异常名称" prefix-icon="el-icon-search"
                              v-model="pagination.name" @blur="loadFaults(true)"></el-input>
                </div>
            </el-col>
            <el-col :span="2">
                <span class="btn-add" @click="handAddFaultProtocol"> <i class="iconfont icon-tianjia1"></i> 新增异常</span>
            </el-col>
        </el-row>

        <div class="factory-research-fault-data-list">
            <el-table :data="faults"
                      v-loading="elLoading"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column label="编号" align="center" prop="uuid"></el-table-column>
                <el-table-column label="名称" align="center" prop="name"></el-table-column>
                <el-table-column label="通知类型" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.faultLevel | faultLevel}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="异常类型" align="center" prop="faultType"></el-table-column>
                <el-table-column label="处理办法" align="center" prop="solution"></el-table-column>
                <el-table-column :label="$t('cao_zuo')" align="center">
                    <template slot-scope="scope">
                        <span @click="handleEditFault(scope.row, scope.$index)"
                              class="research-fault-edit">{{$t('bian_ji')}}</span>
                        <span @click="handleDelete(scope.row, scope.$index)" class="research-fault-delete">{{$t('shan_chu')}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                    @current-change="handleCurrentChange"
                    class="pagination"
                    :current-page="pagination.curPage"
                    :page-size="pagination.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="pagination.total">
            </el-pagination>
        </div>

        <c-dialog class="dialog" :visible.sync="addFaultVisible" :width="'36rem'" :height="'24rem'"
                  title="新增异常协议">
            <el-form class="create-protocol-dialog" label-width="80px">
                <el-form-item label="异常名称">
                    <el-input v-model="fault.name" placeholder="请输入异常名称"></el-input>
                </el-form-item>
                <el-form-item label="异常等级">
                    <el-select
                            placeholder="请选择异常等级" v-model="fault.level">
                        <el-option v-for="item in faultLevelOptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="异常类型">
                    <el-input v-model="fault.faultType" placeholder="请输入异常类型"></el-input>
                </el-form-item>
                <el-form-item label="解决办法">
                    <el-input v-model="fault.solution" type="textarea" :rows="3" placeholder="异常解决办法"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="success" plain @click="faultInfoCreate">{{$t('ti_jiao')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>
        <c-dialog class="dialog" :visible.sync="editFaultVisible" title="编辑异常协议" :width="'36rem'" :height="'24rem'">
            <el-form class="create-protocol-dialog" label-width="100px">
                <el-form-item label="异常名称">
                    <el-input v-model="fault.name"></el-input>
                </el-form-item>
                <el-form-item label="异常等级">
                    <el-select
                            placeholder="请选择" v-model="fault.level">
                        <el-option v-for="item in faultLevelOptions"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label="异常类型">
                    <el-input v-model="fault.faultType"></el-input>
                </el-form-item>
                <el-form-item label="解决办法">
                    <el-input v-model="fault.solution" type="textarea" :rows="3"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="success" plain @click="faultInfoUpdate">{{$t('ti_jiao')}}</el-button>
                </el-form-item>
            </el-form>
        </c-dialog>


    </div>

</template>

<script>
    import CDialog from '@/components/Dialog'
    import {
        faultList,
        faultUnion,
        faultCreate,
        faultUpdate,
        faultDelete,
    } from '@/api/factory/research/fault';
    export default {
        name: '',
        components: {
            CDialog
        },
        mounted: function () {
            this.loadFaults()
        },
        data: function () {
            return {
                faults: [],
                currentPage: 1,
                addFaultVisible: false,
                elLoading: false,
                editFaultVisible: false,
                fault: {
                    uuid: '',
                    productUuid: '',
                    name: '',
                    level: '',
                    faultType: '',
                    solution: ''
                },
                pagination: {
                    name: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
                faultLevelOptions: [
                    {label: '普通通知', value: 0},
                    {label: '媒体通讯通知', value: 1},
                    {label: '短信通知', value: 2},
                    {label: '语音电话通知', value: 3},
                    {label: '强制通知', value: 4},
                ],
            }
        },
        filters: {
            faultLevel (type){
                switch (type) {
                    case 0:
                        return `普通通知`
                    case 1:
                        return `媒体通讯通知`
                    case 2:
                        return `短信通知`
                    case 3:
                        return `语音电话通知`
                    case 4:
                        return `强制通知`
                }
                return `未知通知`
            }
        },
        methods: {
            handleDelete (fault, index){
                this.$confirm('此操作将删除异常类型, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    faultDelete(fault.uuid).then(res => {
                        if (res.code === 0) {
                            this.faults.splice(index, 1)
                        }
                    })
                }).catch(() => {

                })
            },

            handAddFaultProtocol(){
                this.fault = {
                    uuid: '',
                    productUuid: '',
                    name: '',
                    level: 0,
                    faultType: '',
                    solution: ''
                }
                this.addFaultVisible = true
            },

            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                faultList(this.pagination).then(res => {
                    this.faults = res.data
                })
            },

            handleEditFault(data){
                this.fault = data
                this.editFaultVisible = true
            },


            loadFaults(isForce = false){
                let vue = this
                this.elLoading = true
                if (vue.faults.length === 0 || isForce) {
                    faultUnion(this.pagination.name).then(res => {
                        if (res !== null && res.code === 0) {
                            vue.faults = res.data.list || []
                            vue.pagination.total = parseInt(res.data.total)
                        }
                        vue.elLoading = false
                    })
                }
            },

            faultInfoCreate(){
                if (this.fault.name === ``) {
                    this.$message.error('请输入异常名称')
                    return
                }
                if (this.fault.faultType === ``) {
                    this.$message.error('请输入异常类型')
                    return
                }

                if (this.fault.solution === ``) {
                    this.$message.error('请输入解决办法')
                    return
                }

                let data = {
                    name: this.fault.name,
                    level: parseInt(this.fault.level),
                    faultType: this.fault.faultType,
                    solution: this.fault.solution,
                }


                let vue = this
                faultCreate(data).then(res => {
                    if (res !== null && res.code === 0) {
                        data.uuid = res.data
                        vue.faults.push(data)
                        vue.addFaultVisible = false
                    }
                })

            },

            faultInfoUpdate(){
                if (this.fault.name === ``) {
                    this.$message.error('请输入异常名称')
                    return
                }
                if (this.fault.faultType === ``) {
                    this.$message.error('请输入异常类型')
                    return
                }

                if (this.fault.solution === ``) {
                    this.$message.error('请输入解决办法')
                    return
                }


                let vue = this
                faultUpdate(this.fault).then(res => {
                    if (res !== null && res.code === 0) {
                        vue.fault = {
                            uuid: '',
                            productUuid: '',
                            name: '',
                            level: '',
                            faultType: '',
                            solution: ''
                        }
                        vue.editFaultVisible = false
                    }
                })

            },

        },
    }
</script>

<style lang="scss">
    .factory-research-faults {
        padding: $padding $t-padding;
        display: flex;
        flex-direction: column;
        .factory-research-fault-title {
            margin-bottom: $padding;
            .factory-research-fault-title-filter {
                display: flex;
                justify-content: center;
                align-items: center;
                .label {
                    display: inline-block;
                    width: 5rem;
                    font-size: .6rem;
                    color: $f_sec_color;
                    text-align: right;
                }
            }
            .el-input {
                .el-input__inner {
                    height: 24px;
                    line-height: 24px;
                }
                .el-input__icon {
                    line-height: 24px;
                }
            }
            .btn-add {
                margin-left: $padding-5;
                color: $f_color;
                font-size: .6rem;
                padding: $padding-3;
                border-radius: .3rem;
                cursor: pointer;
            }
            .btn-add:hover {
                background-color: $bg_six_color;
                font-weight: $w1;
            }
        }

        .factory-research-fault-data-list {
            flex: 1;
            border-radius: .5rem;
            // background-color: $bg_sec_color;
            padding: $padding;
            .research-fault-edit, .research-fault-delete {
                cursor: pointer;
                display: inline-block;
                margin-right: $padding;
            }
            .research-fault-edit {
                color: $btn_color;
            }
            .research-fault-delete {
                color: $btn_sec_color;
            }

            .pagination {
                margin-top: $padding;
            }
        }

        .dialog {
            .create-protocol-dialog {
                padding: 0 $padding;
                .el-form-item__label {
                    color: $f_sec_color;
                }
                .el-textarea__inner, .el-input__inner {
                    border-color: $bg_999_color;
                    color: $f_th_color;
                }

                .el-textarea__inner {
                    font-size: .6rem;
                }

                .el-button {
                    color: $f_color;
                }

                .protocol-input {
                    p {
                        margin-top: 5px;
                        font-size: 12px;
                        color: #999999;
                    }
                }
            }
        }
    }

</style>
